// ======================================================================
// File Name       : ContentQuestionAddAnswerDialog
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Modal, Form, Col, Button, FormControl } from 'react-bootstrap';
import { MESSAGE_TYPE, MESSAGE_TIME_OUT, MODAL_SIZE, VALIDATE_TYPE } from '../../constants/index';
import FormControlValidate from '../FormControlValidate';
import { ANSWER_FORMULA } from '../../constants/ContentConstant';
import { htmlEntities } from '../../utils/index';

class ContentQuestionAddAnswerDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
    this.okClick = this.okClick.bind(this);
    this.validation = this.validation.bind(this);
  }

  okClick() {
    if (this.validation()) {
      this.props.onOK(this.props.answer.index);
    }
  }

  validation() {
    return Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
  }

  render() {
    const style = {
      background: 'none',
      width: 'auto',
      marginLeft: 0,
      left: 0,
    };
    this.refsToValidate = [];
    const formulaSelectiveType = [
      ANSWER_FORMULA.SELECTIVE_SINGLE_ANSWER,
      ANSWER_FORMULA.SELECTIVE_MULTIPLE_ANSWER,
      ANSWER_FORMULA.SELECTIVE_SORT_ANSWER,
    ];
    const answerFormula = this.props.answerFormula || ANSWER_FORMULA.SELECTIVE_SINGLE_ANSWER;
    const isFormulaSelectiveType = formulaSelectiveType.indexOf(answerFormula) > -1;
    const data = this.props.answer;
    const isOverlapCorrectAnswerNumber =
      this.props.answerInfo.filter(
        (item, index) =>
          item.correctAnswerNumber == data.correctAnswerNumber && index !== data.index,
      ).length > 0;
    const answerListView = data.subAnswer
      ? data.subAnswer.map((subAnswer, index) =>
        (<Form.Group key={index} className="form-info" controlId="formInlineName">
          <Col as={Form.Label} sm={3}>
            または
          </Col>
          {/* DISPLAYING ADD SUB ANSWER
            * Answer formula is single answer (long answer) we display textarea field
            * Other formula will display text field
            */}
          { answerFormula !== ANSWER_FORMULA.DESCRIPTIVE_SINGLE_ANSWER_LONG_ANSWER ?
            <Col sm={7} className="button-form">
              <FormControlValidate
                type="text"
                name="subAnswer"
                value={subAnswer ? htmlEntities(subAnswer, false) : ''}
                onChange={this.props.handleSubAnswerChange.bind(this, index)}
                maxLength="1024"
                label="または"
                ref={(ref) => {
                  if (ref) {
                    this.refsToValidate.push(ref);
                  }
                }}
                validateType={VALIDATE_TYPE.CORRECT_ANSWER}
              />
            </Col>
            :
            <Col sm={7} className="button-form">
              <FormControlValidate
                as="textarea"
                className="textArea height-135px"
                name="subAnswer"
                onChange={this.props.handleSubAnswerChange.bind(this, index)}
                value={subAnswer ? htmlEntities(subAnswer, false) : ''}
                maxLength="1024"
                label="または"
                ref={(ref) => {
                  if (ref) {
                    this.refsToValidate.push(ref);
                  }
                }}
                validateType={VALIDATE_TYPE.CORRECT_ANSWER}
              />
            </Col>
          }
        </Form.Group>),
        )
      : null;

    const header = isFormulaSelectiveType ? '選択肢を追加してください' : '正答情報を追加してください';
    let body = (
      <Modal.Body className="padding-10">
        <Col sm={12} />
      </Modal.Body>
    );
    if (isFormulaSelectiveType) {
      body = (
        <Modal.Body className="padding-10">
          <Col sm={12}>
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                this.okClick();
              }}
              className='form-horizontal'
            >
              <Form.Group className="form-info">
                <Col as={Form.Label} sm={3}>
                  選択肢
                </Col>
                <Col sm={7}>
                  <FormControlValidate
                    type="text"
                    name="answerChoice"
                    value={data.answerChoice}
                    onChange={this.props.handleAnswerChange}
                    maxLength="1024"
                    label="選択肢"
                    required
                    ref={(ref) => {
                      if (ref) {
                        this.refsToValidate.push(ref);
                      }
                    }}
                    notValidationBlur
                  />
                </Col>
              </Form.Group>
              {answerFormula !== ANSWER_FORMULA.SELECTIVE_SORT_ANSWER
                ? <Form.Group className="form-info">
                  <Col as={Form.Label} sm={3}>
                    正解
                  </Col>
                  <Col sm={7}>
                    <Form.Check
                      type='checkbox'
                      className="margin-left-30 margin-top-5"
                      name="isCorrectAnswer"
                      id="isCorrectAnswer"
                      checked={data.isCorrectAnswer}
                      onChange={this.props.handleAnswerChange} />
                  </Col>
                </Form.Group>
                : <Form.Group className="form-info">
                  <Col as={Form.Label} sm={3}>
                    正解番号
                  </Col>
                  <Col sm={7}>
                    <FormControlValidate
                      type="text"
                      name="correctAnswerNumber"
                      value={data.correctAnswerNumber}
                      onChange={this.props.handleAnswerChange}
                      label="正解番号"
                      ref={(ref) => {
                        if (ref) {
                          this.refsToValidate.push(ref);
                        }
                      }}
                      isOverlap={isOverlapCorrectAnswerNumber}
                      validateType={VALIDATE_TYPE.NUMBERIC_OVERLAP}
                    />
                  </Col>
                </Form.Group>
              }
            </Form>
          </Col>
        </Modal.Body>
      );
    } else {
      body = (
        <Modal.Body className="padding-10">
          <Col sm={12} className="text-center">
            ※表記ゆれを正答とする場合は、追加ボタンから正答を追加してください
          </Col>
          <Col sm={12} className="margin-top-10">
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                this.okClick();
              }}
              className='form-horizontal'
            >
              <Form.Group className="form-info">
                <Col as={Form.Label} sm={3}>
                    正解
                </Col>
                <Col sm={7}>
                  { answerFormula !== ANSWER_FORMULA.DESCRIPTIVE_SINGLE_ANSWER_LONG_ANSWER ?
                    <FormControlValidate
                      type="text"
                      name="correctAnswer"
                      value={data.correctAnswer ? htmlEntities(data.correctAnswer, false) : ''}
                      onChange={this.props.handleAnswerChange}
                      maxLength="1024"
                      label="正解"
                      required
                      ref={(ref) => {
                        if (ref) {
                          this.refsToValidate.push(ref);
                        }
                      }}
                      validateType={VALIDATE_TYPE.CORRECT_ANSWER}
                    />
                    :
                    <FormControlValidate
                      as="textarea"
                      className="textArea height-135px"
                      name="correctAnswer"
                      onChange={this.props.handleAnswerChange}
                      value={data.correctAnswer ? htmlEntities(data.correctAnswer, false) : ''}
                      maxLength="1024"
                      label="正解"
                      required
                      ref={(ref) => {
                        if (ref) {
                          this.refsToValidate.push(ref);
                        }
                      }}
                      validateType={VALIDATE_TYPE.CORRECT_ANSWER}
                    />
                  }
                </Col>
              </Form.Group>
              {answerListView}
              <Form.Group className="form-info">
                <Col sm={3} />
                <Col sm={7}>
                  <Button variant="primary" className="btn-96" onClick={this.props.addSubAnswer}>
                    追加
                  </Button>
                </Col>
              </Form.Group>
              {answerFormula === ANSWER_FORMULA.DESCRIPTIVE_MULTIPLE_ANSWER_ORDER &&
                <Form.Group className="form-info">
                  <Col as={Form.Label} sm={3}>
                    正解番号
                  </Col>
                  <Col sm={7}>
                    <FormControlValidate
                      type="text"
                      name="correctAnswerNumber"
                      value={data.correctAnswerNumber}
                      onChange={this.props.handleAnswerChange}
                      label="正解番号"
                      ref={(ref) => {
                        if (ref) {
                          this.refsToValidate.push(ref);
                        }
                      }}
                      isOverlap={isOverlapCorrectAnswerNumber}
                      validateType={VALIDATE_TYPE.NUMBERIC_OVERLAP}
                      required
                    />
                  </Col>
                </Form.Group>}
            </Form>
          </Col>
        </Modal.Body>
      );
    }
    return (
      <Modal
        className="modal-container"
        show={this.props.showModal}
        size={MODAL_SIZE.md}
        style={style}
      >
        <Modal.Header onHide={this.props.onCancel} closeButton>
          <Modal.Title className="text-center">
            {header}
          </Modal.Title>
        </Modal.Header>

        {body}
        <Modal.Footer className="text-center">
          <Button variant="default" className="btn-96 margin-10" onClick={this.props.onCancel}>
            キャンセル
          </Button>
          <Button variant="primary" className="btn-96 margin-10" onClick={this.okClick}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default ContentQuestionAddAnswerDialog;
